"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTimeBlock = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../app");
const auth_1 = require("../utils/auth");
const confirm_1 = require("../utils/confirm");
const notification_center_1 = require("../widgets/notification_center");
const booking_window_1 = require("./booking_window");
const calendar_1 = require("./calendar");
const moment = require("moment");
const RULER_BOLD = 60;
const RULER_THIN = 30;
const ondragover = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.redraw = false;
};
const ondragenter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.redraw = false;
    e.target.classList.add("drag-target");
};
function ondragleave(e) {
    e.preventDefault();
    e.stopPropagation();
    e.redraw = false;
    e.target.classList.remove("drag-target");
}
function ondrop(dayModel, room) {
    return function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.target.classList.remove("drag-target");
        let bookingId = e.dataTransfer.getData('booking_id');
        if (bookingId) {
            let booking = dayModel.getBooking(bookingId);
            let details = booking.details;
            if (details) {
                let bookingDate = booking.from;
                let date = e.target.dataset.date;
                let currentRoom = dayModel.getRoomFromBookingId(bookingId);
                let d1 = moment(bookingDate);
                let d2 = moment(date);
                if (d1.isSame(d2) && currentRoom.id == room.id) {
                    e.redraw = false;
                }
                else {
                    booking.loading = true;
                    app_1.App.patch(`/bookings/${details.id}/simulate_move`, {
                        new_date: date,
                        new_room_id: room.id
                    }).then((x) => {
                        let details = booking.details;
                        let mr = x;
                        if (mr.move) {
                            if (mr.has_cost) {
                                notification_center_1.Notification.error("Impossible de déplacer car le déplacement implique un coût.");
                                booking.loading = false;
                            }
                            else {
                                const moveBooking = () => {
                                    // Apply the move
                                    app_1.App.patch(`/bookings/${details.id}/move`, {
                                        new_date: date,
                                        new_room_id: room.id
                                    }).then((x) => {
                                        let b = x;
                                        booking.from = b.from;
                                        booking.to = b.to;
                                        booking.duration = b.duration;
                                        booking.details = b.details;
                                        booking.type = b.type;
                                        booking.loading = false;
                                        dayModel.moveBooking(booking, room);
                                        calendar_1.Calendar.refresh();
                                    });
                                };
                                if (!moment(date).isSame(moment(booking.real_from)) && room.id) {
                                    confirm_1.Confirm.confirm("Vous êtes sur le point de déplacer une réservation" +
                                        " hors de ses heures actuelles. Etes-vous sûr?").then(moveBooking).finally(() => { booking.loading = false; mithril_1.default.redraw(); });
                                }
                                else {
                                    moveBooking();
                                }
                            }
                        }
                        else {
                            let reason;
                            switch (mr.reason) {
                                case "confirmed":
                                    reason = "la réservation est déjà confirmée.";
                                    break;
                                case "services":
                                    reason = "la salle ne possède pas les services nécéssaires.";
                                    break;
                                case "availability":
                                    reason = "le créneau est déjà pris.";
                                    break;
                                case "not_same_hours":
                                    reason = `l'heure choisie est différente de l'heure initiale de la réservation ${booking.real_from}`;
                                    break;
                                case "client_error":
                                    reason = mr.extra;
                                    break;
                                default:
                                    reason = `une erreur s'est produite (${mr.reason}).`;
                                    break;
                            }
                            notification_center_1.Notification.error("Impossible de déplacer la réservation ici car " + reason);
                            booking.loading = false;
                        }
                    });
                }
            }
        }
    };
}
function createTimeBlock(dayModel, time, currentTime, room, disabled) {
    const totalTime = calendar_1.Calendar.totalTime();
    const rulerSizeInPercent = 100 * (app_1.App.BOOKING_STEP / totalTime);
    let style = '';
    if (time % RULER_BOLD == 0) {
        style = 'mcal-ruler-bold';
    }
    else if (time % RULER_THIN == 0) {
        style = 'mcal-ruler-thin';
    }
    const date = currentTime.format();
    let attrs = {
        class: `mcal-ruler ${style} ${disabled ? 'disabled' : ''}`,
        "data-date": date,
        "data-room-id": room.id,
        key: `${room.id}-${date}`,
        style: `height: ${rulerSizeInPercent}%;`,
        onclick: () => {
            let startAt = dayModel.day.clone();
            startAt = startAt.tz(app_1.App.BOOKING_TIMEZONE).startOf('day');
            startAt.add(time, 'minutes');
            booking_window_1.BookingWindow.open(startAt, dayModel.data.venue.id, room.id);
        },
        title: currentTime.format('HH:mm')
    };
    if (auth_1.Auth.isAdmin()) {
        attrs = Object.assign(attrs, {
            ondragover: ondragover,
            ondragenter: ondragenter,
            ondragleave: ondragleave,
            ondrop: ondrop(dayModel, room)
        });
    }
    return (0, mithril_1.default)("div", attrs);
}
exports.createTimeBlock = createTimeBlock;
